import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { toast } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import RefundModal from 'src/components/transactions/RefundModal';
import { FEE_TYPES_NAME, TRANSACTION_STATUSES_NAMES, TRANSACTION_TYPES, TRANSACTION_TYPESV2 } from 'src/constants/payments';
import { useStore } from 'src/stores';
import { useDelay } from 'src/utils/hooks';
import SearchBar from './SearchBar';
import { TransactionsTable } from './TransactionsTable';
export const Transactions = observer(props => {
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const accountId = props.accountId,
    overviewData = props.overviewData,
    residencyId = props.residencyId,
    propertyId = props.propertyId,
    triggerRefresh = props.triggerRefresh,
    setTriggerRefresh = props.setTriggerRefresh;
  const _useState = useState(moment(store.properties.serverBusinessDateOnly).startOf('month').subtract(12, 'month').toDate()),
    _useState2 = _slicedToArray(_useState, 2),
    fromDate = _useState2[0],
    setFromDate = _useState2[1];
  const _useState3 = useState(moment(store.properties.serverBusinessDateOnly).endOf('month').toDate()),
    _useState4 = _slicedToArray(_useState3, 2),
    toDate = _useState4[0],
    setToDate = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    searchKey = _useState6[0],
    setSearchKey = _useState6[1];
  const _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    transactionsHistoryData = _useState8[0],
    setTransactionsHistoryData = _useState8[1];
  const _useState9 = useState('all'),
    _useState0 = _slicedToArray(_useState9, 2),
    transactionSubType = _useState0[0],
    setTransactionSubType = _useState0[1];
  const _useState1 = useState('all'),
    _useState10 = _slicedToArray(_useState1, 2),
    transactionType = _useState10[0],
    setTransactionType = _useState10[1];
  const _useState11 = useState({}),
    _useState12 = _slicedToArray(_useState11, 2),
    transactionTypes = _useState12[0],
    setTransactionTypes = _useState12[1];
  const _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    utilities = _useState14[0],
    setUtilities = _useState14[1];
  const getPaymentCheckType = type => type === 'CheckMoneyOrder' ? t('resident_account.check_money_order') : type;
  const isTransactionFailedDescription = tr => {
    var _tr$metadata;
    return ((_tr$metadata = tr.metadata) === null || _tr$metadata === void 0 ? void 0 : _tr$metadata.status) === TRANSACTION_STATUSES_NAMES.Failed ? ' ' : undefined;
  };
  const isTransactionPendingDescription = tr => {
    var _tr$metadata2;
    return ((_tr$metadata2 = tr.metadata) === null || _tr$metadata2 === void 0 ? void 0 : _tr$metadata2.status) === TRANSACTION_STATUSES_NAMES.InProgress ? ' ' : undefined;
  };
  const getPeriodByCard = tr => {
    var _tr$metadata3;
    return !!((_tr$metadata3 = tr.metadata) !== null && _tr$metadata3 !== void 0 && _tr$metadata3.last4) ? "" : isTransactionFailedDescription(tr) || isTransactionPendingDescription(tr) || '';
  };
  const getServicePeriods = tr => {
    var _tr$metadata4, _tr$metadata5, _tr$metadata6, _tr$metadata7;
    return (_tr$metadata4 = tr.metadata) !== null && _tr$metadata4 !== void 0 && _tr$metadata4.serviceStartDateOnly && (_tr$metadata5 = tr.metadata) !== null && _tr$metadata5 !== void 0 && _tr$metadata5.serviceEndDateOnly ? "\n      Service period: ".concat(moment((_tr$metadata6 = tr.metadata) === null || _tr$metadata6 === void 0 ? void 0 : _tr$metadata6.serviceStartDateOnly).format('MM/DD/YYYY'), " - ").concat(moment((_tr$metadata7 = tr.metadata) === null || _tr$metadata7 === void 0 ? void 0 : _tr$metadata7.serviceEndDateOnly).format('MM/DD/YYYY'), "\n    ") : '';
  };
  const getVoidedTransaction = (resp, transaction) => {
    var _resp$response;
    return TRANSACTION_TYPES[resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 || (_resp$response = _resp$response.transactions.find(tr => {
      var _transaction$metadata;
      return tr.id === ((_transaction$metadata = transaction.metadata) === null || _transaction$metadata === void 0 ? void 0 : _transaction$metadata.voidedTransactionId);
    })) === null || _resp$response === void 0 ? void 0 : _resp$response.transactionType];
  };
  const insertAt = (str, sub, pos) => "".concat(str.slice(0, pos)).concat(sub).concat(str.slice(pos));
  const fetchDataV2 = async () => {
    if ((overviewData === null || overviewData === void 0 ? void 0 : overviewData.billingStartDateOnly) === 'N/A') return;
    const utilityDataSet = new Set();
    const resp = await store.payment.getResidentAccountTransactionHistoryV2Async.run({
      fromUtc: moment(fromDate).startOf('day').utc().toISOString(),
      toUtc: moment(toDate).endOf('day').utc().toISOString(),
      accountId: accountId
    });
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      var _resp$response2, _resp$response3, _utilityInfoResp;
      const firstTransaction = {
        id: -1,
        // NOTE: due to sorting first transaction should be always at the bottom
        summary: {
          month: moment(overviewData === null || overviewData === void 0 ? void 0 : overviewData.billingStartDateOnly).format('MMMM'),
          isMoveInMonth: true,
          startingBalance: insertAt("".concat(Number(resp === null || resp === void 0 || (_resp$response2 = resp.response) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.startingBalance).toFixed(2)), '$ ', 0)
        }
      };
      const types = {};
      const utilityIds = resp === null || resp === void 0 || (_resp$response3 = resp.response) === null || _resp$response3 === void 0 ? void 0 : _resp$response3.transactions.map(i => i.metadata.utilityId).filter(i => !!i);
      let utilityInfoResp;
      if (!store.account.featureFlagsStore.getIsBillAutomationEnabled || !store.account.featureFlagsStore.getIsBillingTemplatesEnabled) {
        utilityInfoResp = await store.utilityProviders.getUtilityInfoAsync.run({
          utilityIds
        });
      } else {
        utilityInfoResp = await store.utilityProviders.getPropertyUtilityInfoAsync.run({
          propertyId,
          utilityIds
        });
      }
      if ((_utilityInfoResp = utilityInfoResp) !== null && _utilityInfoResp !== void 0 && _utilityInfoResp.isSuccessful) {
        var _resp$response4, _store$payment$getRes;
        const utilitiesInfo = utilityInfoResp.response.utilities;
        utilitiesInfo.map(u => utilityDataSet.add(u));
        const transactionsGroupedByMonth = resp === null || resp === void 0 || (_resp$response4 = resp.response) === null || _resp$response4 === void 0 ? void 0 : _resp$response4.transactions.reduce((prev, current) => {
          const resultObj = Object.assign({}, prev);
          let monthGroupKey;
          if (store.company.companyFeatureStore.isAppfolio && moment(current['statementDateOnly']).date() <= 15) {
            monthGroupKey = moment(current['statementDateOnly']).subtract(1, 'month').utc().format('YYYYMM');
          } else {
            monthGroupKey = moment(current['statementDateOnly']).utc().format('YYYYMM');
          }
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          Array.isArray(resultObj[monthGroupKey]) ? resultObj[monthGroupKey].push(current) : resultObj[monthGroupKey] = [current];
          return resultObj;
        }, {});
        const result = Object.entries(transactionsGroupedByMonth).sort((_ref, _ref2) => {
          let _ref3 = _slicedToArray(_ref, 1),
            keyA = _ref3[0];
          let _ref4 = _slicedToArray(_ref2, 1),
            keyB = _ref4[0];
          return keyA - keyB;
        }).map((i, index, array) => {
          const periodMonth = i[0];
          const periodTransactions = i[1].reverse();
          return {
            id: index,
            summary: {
              month: moment(periodMonth).format('MMMM'),
              isEndOfPeriod: array.length - index === 1,
              isSummary: array.length - index !== 1,
              balanceOnFirst: insertAt("".concat(Number(periodTransactions[periodTransactions.length - 1].balanceBefore).toFixed(2)), '$ ', 0),
              monthlyCharges: insertAt("".concat(Number(periodTransactions.reduce((previousValue, currentValue) => {
                var _currentValue$metadat;
                if ([TRANSACTION_STATUSES_NAMES.Failed, TRANSACTION_STATUSES_NAMES.InProgress].includes(currentValue === null || currentValue === void 0 || (_currentValue$metadat = currentValue.metadata) === null || _currentValue$metadat === void 0 ? void 0 : _currentValue$metadat.status) || currentValue !== null && currentValue !== void 0 && currentValue.isInformational) {
                  return previousValue;
                }
                return currentValue.amount > 0 ? parseFloat(previousValue) + parseFloat(currentValue.amount) : previousValue;
              }, 0)).toFixed(2)), '$ ', 0),
              paymentsAndCredits: insertAt("".concat((Number(periodTransactions.reduce((previousValue, currentValue) => {
                var _currentValue$metadat2;
                if ([TRANSACTION_STATUSES_NAMES.Failed, TRANSACTION_STATUSES_NAMES.InProgress].includes(currentValue === null || currentValue === void 0 || (_currentValue$metadat2 = currentValue.metadata) === null || _currentValue$metadat2 === void 0 ? void 0 : _currentValue$metadat2.status) || currentValue !== null && currentValue !== void 0 && currentValue.isInformational) {
                  return previousValue;
                }
                return currentValue.amount < 0 ? parseFloat(previousValue) + parseFloat(currentValue.amount) : previousValue;
              }, 0)) * -1).toFixed(2)), '$ ', 0),
              currentBalance: insertAt("".concat(Number(periodTransactions[0].balanceAfter).toFixed(2)), '$ ', 0)
            },
            transactions: periodTransactions.map(transaction => {
              // eslint-disable-next-line @typescript-eslint/no-shadow
              const getFields = transaction => {
                switch (transaction.transactionType) {
                  case TRANSACTION_TYPESV2.CapCredit:
                    {
                      var _utilitiesInfo$find;
                      return {
                        period: getServicePeriods(transaction),
                        service: (_utilitiesInfo$find = utilitiesInfo.find(utility => {
                          var _transaction$metadata2;
                          return (utility === null || utility === void 0 ? void 0 : utility.utilityId) === (transaction === null || transaction === void 0 || (_transaction$metadata2 = transaction.metadata) === null || _transaction$metadata2 === void 0 ? void 0 : _transaction$metadata2.utilityId);
                        })) === null || _utilitiesInfo$find === void 0 ? void 0 : _utilitiesInfo$find.utilityTypeName,
                        type: TRANSACTION_TYPES.CapCredit
                      };
                    }
                  case TRANSACTION_TYPESV2.Fee:
                    {
                      var _transaction$metadata3;
                      return {
                        service: FEE_TYPES_NAME[(_transaction$metadata3 = transaction.metadata) === null || _transaction$metadata3 === void 0 ? void 0 : _transaction$metadata3.feeType] || 'N/A'
                      };
                    }
                  case TRANSACTION_TYPESV2.LateFee:
                    {
                      return {
                        type: TRANSACTION_TYPES.LateFee
                      };
                    }
                  case TRANSACTION_TYPESV2.UtilityCharge:
                    {
                      var _utilitiesInfo$find2;
                      return {
                        period: getServicePeriods(transaction),
                        service: (_utilitiesInfo$find2 = utilitiesInfo.find(utility => {
                          var _transaction$metadata4;
                          return (utility === null || utility === void 0 ? void 0 : utility.utilityId) === (transaction === null || transaction === void 0 || (_transaction$metadata4 = transaction.metadata) === null || _transaction$metadata4 === void 0 ? void 0 : _transaction$metadata4.utilityId);
                        })) === null || _utilitiesInfo$find2 === void 0 ? void 0 : _utilitiesInfo$find2.utilityTypeName,
                        type: TRANSACTION_TYPES.UtilityCharge
                      };
                    }
                  case TRANSACTION_TYPESV2.UtilityCredit:
                    {
                      var _transaction$metadata5, _utilitiesInfo$find3;
                      return {
                        period: ((_transaction$metadata5 = transaction.metadata) === null || _transaction$metadata5 === void 0 ? void 0 : _transaction$metadata5.reason) + ',' + getServicePeriods(transaction),
                        service: (_utilitiesInfo$find3 = utilitiesInfo.find(utility => {
                          var _transaction$metadata6;
                          return (utility === null || utility === void 0 ? void 0 : utility.utilityId) === (transaction === null || transaction === void 0 || (_transaction$metadata6 = transaction.metadata) === null || _transaction$metadata6 === void 0 ? void 0 : _transaction$metadata6.utilityId);
                        })) === null || _utilitiesInfo$find3 === void 0 ? void 0 : _utilitiesInfo$find3.utilityTypeName,
                        type: TRANSACTION_TYPES.UtilityCredit
                      };
                    }
                  case TRANSACTION_TYPESV2.Payment:
                  case TRANSACTION_TYPESV2.Refund:
                    {
                      var _transaction$metadata7;
                      return {
                        period: getPeriodByCard(transaction, transaction.transactionType.toLowerCase()),
                        service: "".concat((_transaction$metadata7 = transaction.metadata) === null || _transaction$metadata7 === void 0 ? void 0 : _transaction$metadata7.paymentMethodType),
                        type: transaction.transactionType
                      };
                    }
                  case TRANSACTION_TYPESV2.Void:
                    {
                      return {
                        period: getServicePeriods(transaction),
                        service: getVoidedTransaction(resp, transaction),
                        type: TRANSACTION_TYPES.Void
                      };
                    }
                  case TRANSACTION_TYPESV2.CheckPayment:
                    {
                      var _transaction$metadata8, _transaction$metadata9;
                      return {
                        period: "Reference number: ".concat((_transaction$metadata8 = transaction.metadata) === null || _transaction$metadata8 === void 0 ? void 0 : _transaction$metadata8.referenceNumber, " Posted at: ").concat(transaction.metadata.postDate),
                        service: getPaymentCheckType((_transaction$metadata9 = transaction.metadata) === null || _transaction$metadata9 === void 0 ? void 0 : _transaction$metadata9.paymentType),
                        type: TRANSACTION_TYPES.Payment
                      };
                    }
                  case TRANSACTION_TYPESV2.CustomCharge:
                    {
                      return {
                        type: TRANSACTION_TYPES.CustomCharge
                      };
                    }
                  case TRANSACTION_TYPESV2.CustomCredit:
                    {
                      return {
                        type: TRANSACTION_TYPES.CustomCredit
                      };
                    }
                  case TRANSACTION_TYPESV2.AdminFee:
                    {
                      return {
                        type: TRANSACTION_TYPES.AdminFee
                      };
                    }
                  case TRANSACTION_TYPESV2.PaperStatementFee:
                    {
                      return {
                        type: TRANSACTION_TYPES.PaperStatementFee
                      };
                    }
                  case TRANSACTION_TYPESV2.StatementCapCredit:
                    {
                      return {
                        type: TRANSACTION_TYPES.StatementCapCredit
                      };
                    }
                  default:
                    {
                      return {
                        type: transaction.transactionType
                      };
                    }
                }
              };
              if (!types[transaction.transactionType]) types[transaction.transactionType] = true;
              return Object.assign(transaction, {
                transactionDateTime: moment(transaction.timestamp).toDate(),
                time: moment(transaction.timestamp).format('MM/DD/YYYY hh:mm A'),
                type: transaction.transactionType,
                isCharge: transaction.amount > 0,
                isCredit: transaction.amount < 0,
                amountOriginal: transaction.amount,
                amount: insertAt("".concat(Number(transaction.amount < 0 ? transaction.amount * -1 : transaction.amount).toFixed(2)), '$ ', 0)
              }, getFields(transaction));
            })
          };
        });
        setTransactionsHistoryData([firstTransaction, ...result]);
        setTransactionTypes(types);
        setUtilities(Array.from(utilityDataSet));
        if ((_store$payment$getRes = store.payment.getResidentAccountTransactionHistoryV2Async) !== null && _store$payment$getRes !== void 0 && (_store$payment$getRes = _store$payment$getRes.error) !== null && _store$payment$getRes !== void 0 && _store$payment$getRes.errorResp) {
          toast('error', store.payment.getResidentAccountTransactionHistoryV2Async.error.errorResp);
        }
      }
    }
  };
  useDelay(fetchDataV2, [fromDate, store.transaction.updateData, toDate, overviewData, triggerRefresh], 700);
  const areTypesEqual = type => type.toLowerCase() === transactionType.toLowerCase();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchBar, {
    key: accountId + residencyId,
    externalSearchValue: setSearchKey,
    externalTransactionSubType: setTransactionSubType,
    externalTransactionType: setTransactionType,
    externalStartDateRange: setFromDate,
    externalEndDateRange: setToDate,
    externalStartDateRangeInit: store.properties.serverBusinessDateOnly,
    externalEndDateRangeInit: store.properties.serverBusinessDateOnly,
    externalUtilityTypesInfo: utilities,
    transactionTypes: transactionTypes
  }), [transactionsHistoryData].flat().sort((a, b) => parseFloat(b.id) - parseFloat(a.id)).map(item => {
    var _item$transactions;
    // local filtering
    const filteredTransactions = (_item$transactions = item.transactions) === null || _item$transactions === void 0 ? void 0 : _item$transactions.filter(tr => {
      switch (transactionType) {
        case TRANSACTION_TYPES.Fee:
          return transactionSubType === 'all' ? areTypesEqual(tr.type) || tr.type.toLowerCase() === TRANSACTION_TYPES.LateFee.toLowerCase() : (areTypesEqual(tr.type) || tr.type.toLowerCase() === TRANSACTION_TYPES.LateFee.toLowerCase()) && (tr.service === transactionSubType || tr.service === FEE_TYPES_NAME[transactionSubType] || tr.type === FEE_TYPES_NAME[transactionSubType]);
        case TRANSACTION_TYPES.CapCredit:
        case TRANSACTION_TYPES.Payment:
        case TRANSACTION_TYPES.UtilityCharge:
          return transactionSubType === 'all' ? areTypesEqual(tr.type) : areTypesEqual(tr.type) && (tr.service === transactionSubType || tr.service === FEE_TYPES_NAME[transactionSubType]);
        case TRANSACTION_TYPES.Credit:
        case TRANSACTION_TYPES.CustomCredit:
        case TRANSACTION_TYPES.CustomCharge:
        case TRANSACTION_TYPES.Refund:
        case TRANSACTION_TYPES.Void:
        case TRANSACTION_TYPES.AdminFee:
        case TRANSACTION_TYPES.PaperStatementFee:
        case TRANSACTION_TYPES.StatementCapCredit:
          return areTypesEqual(tr.type);
        case 'all':
          return true;
      }
    });
    return item.transactions ? _objectSpread(_objectSpread({}, item), {}, {
      transactions: filteredTransactions
    }) : _objectSpread({}, item);
  }).map(i => {
    var _i$transactions;
    // local search
    const filteredTransactions = (_i$transactions = i.transactions) === null || _i$transactions === void 0 ? void 0 : _i$transactions.filter(tr => {
      const searchPhrase = new RegExp(searchKey, 'gi');
      return searchKey.length > 0 ? " ".concat(tr.type).search(searchPhrase) > 0 || " ".concat(tr.service).search(searchPhrase) > 0 || " ".concat(tr.period).search(searchPhrase) > 0 : true;
    });
    return i.transactions ? _objectSpread(_objectSpread({}, i), {}, {
      transactions: filteredTransactions
    }) : _objectSpread({}, i);
  }).map((data, index) => /*#__PURE__*/React.createElement(TransactionsTable, {
    key: index,
    data: data,
    triggerRefresh: triggerRefresh,
    setTriggerRefresh: setTriggerRefresh
  })), /*#__PURE__*/React.createElement(RefundModal, {
    handleClose: () => store.transaction.setRefundModalIsOpen(false),
    isOpen: store.transaction.refundModalIsOpen,
    triggerRefresh: triggerRefresh,
    setTriggerRefresh: setTriggerRefresh
  }));
});